<template>
  <canvas id="watermarkCanvas" class="watermark"></canvas>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.watermark();
  },
  watch: {
    text: {
      handler() {
        this.watermark();
      },
    },
  },
  methods: {
    watermark() {
      var canvas = document.getElementById("watermarkCanvas");
      var ctx = canvas.getContext("2d");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      var width = canvas.width;
      var height = canvas.height;
      ctx.font = "14px Noto Sans SC";
      ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // 旋转并重复绘制水印文本
      for (var x = 0; x < width; x += 120) {
        for (var y = 0; y < height; y += 120) {
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(-Math.PI / 6);
          ctx.fillText(this.text, 0, 0);
          ctx.restore();
        }
      }
    },
  },
};
</script>

<style>
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: none;
  opacity: 0.2;
}
</style>


// WEBPACK FOOTER //
// src/components/watermark.vue